import React from 'react'
import classnames from 'classnames'

interface Props {
  className?: string
}

const EmailIcon = ({className}: Props): JSX.Element => {
  const emailClassname = classnames('email-icon', className)
  return (
    <svg className={emailClassname} x="0" y="0" viewBox="0 0 40 40">
      <path d="M20 17.5L38.4 4.4C38 4.1 37.5 4 37 4H3c-.5 0-1 .1-1.4.4L20 17.5z" />
      <path d="M21.2 21.6c-.4.3-.8.4-1.2.4s-.8-.1-1.2-.4L0 8.2V33c0 1.7 1.3 3 3 3h34c1.7 0 3-1.3 3-3V8.2L21.2 21.6z" />
      <path d="M0 5.7L20 20 40 5.7" className="outline" />
    </svg>
  )
}

export default EmailIcon
